import { LAYOUT } from '@wix/live-video-commons';
import React, { useEffect } from 'react';
import { DH } from '../../data-hooks';
import { FocusedLayout } from './layouts/focused-layout';
import { GridLayout } from './layouts/grid-layout';
import { useSession } from './session-provider';
import { useVideoConfig } from './video-config-provider';
import s from './video.scss';
export const Video = () => {
    const { layout, onJoinedSuccessfully, webinar, mobile, sidePanelOpened } = useVideoConfig();
    const { sharingAttendeeId, attendees } = useSession();
    const currentLayout = getCurrentLayout(layout, webinar, attendees.length, !!sharingAttendeeId, mobile, sidePanelOpened);
    useEffect(() => {
        void (onJoinedSuccessfully === null || onJoinedSuccessfully === void 0 ? void 0 : onJoinedSuccessfully());
    }, []);
    return (React.createElement("div", { className: s.container, "data-hook": DH.VIDEO_CONTAINER }, currentLayout === LAYOUT.GRID ? React.createElement(GridLayout, null) : React.createElement(FocusedLayout, null)));
};
const getCurrentLayout = (layout, webinar, attendeesCount, sharing, mobile, sidePanelOpened) => {
    if (sharing) {
        return LAYOUT.FOCUSED;
    }
    if (webinar) {
        return attendeesCount > 1 ? LAYOUT.GRID : LAYOUT.FOCUSED;
    }
    if (mobile && sidePanelOpened) {
        return LAYOUT.GRID;
    }
    return layout;
};
//# sourceMappingURL=video.js.map